// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_5RaDc","dots":"_00gVS","dot":"YPPxo","item":"DI3J4","active":"Q4Blc"};